import { render, staticRenderFns } from "./assetDepreciationList.vue?vue&type=template&id=1787ca1a"
import script from "./assetDepreciationList.vue?vue&type=script&lang=js"
export * from "./assetDepreciationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports